/**
 * Compact collection toolbar: facet pills + price-sort triangles + product spotlight.
 */

function kdEscapeAttr(value) {
  if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') return CSS.escape(value);
  return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

function kdGetToolbarRoot() {
  return document.querySelector('.kd-collection-toolbar');
}

function kdGetFacetForm() {
  return document.getElementById('FacetFiltersForm');
}

function kdPrimaryFilterSyncFromFacets(form) {
  const root = kdGetToolbarRoot();
  const wrap = document.getElementById('KdPrimaryPills');
  if (!root || !wrap || !form) return;

  const param = root.dataset.filterParam;
  if (!param) return;

  const boxes = [...form.querySelectorAll(`input[type="checkbox"][name="${kdEscapeAttr(param)}"]`)];
  if (!boxes.length) return;

  const active = boxes.find((cb) => cb.checked && !cb.disabled);

  wrap.querySelectorAll('.kd-toolbar-pill').forEach((btn) => {
    const raw = btn.dataset.value ?? '';
    const isAll = btn.dataset.all === 'true';
    const on =
      active == null ? isAll || raw === '' : !isAll && raw !== '' && active.value === raw;
    btn.classList.toggle('kd-toolbar-pill--active', !!on);
    btn.setAttribute('aria-checked', on ? 'true' : 'false');
  });
}

function kdFacetFilterApplyToFacets(form, param, targetVal) {
  if (!form || !param) return false;

  const boxes = [...form.querySelectorAll(`input[type="checkbox"][name="${kdEscapeAttr(param)}"]`)];
  if (!boxes.length) return false;

  const want = typeof targetVal === 'string' ? targetVal.trim() : '';
  let changed = false;
  boxes.forEach((cb) => {
    const next = !!(want && cb.value === want);
    if (cb.checked !== next) {
      cb.checked = next;
      changed = true;
    }
  });
  if (changed && boxes[0]) {
    boxes[0].dispatchEvent(new Event('input', { bubbles: true }));
  }
  return changed;
}

function kdPrimaryFilterApplyToFacets(form, targetVal) {
  const root = kdGetToolbarRoot();
  if (!root || !form) return false;
  return kdFacetFilterApplyToFacets(form, root.dataset.filterParam, targetVal);
}

function kdComfortFilterSyncFromFacets(form) {
  const root = kdGetToolbarRoot();
  const select = document.getElementById('KdComfortFilter');
  if (!root || !select || !form) return;

  const param = root.dataset.comfortFilterParam;
  if (!param) return;

  const boxes = [...form.querySelectorAll(`input[type="checkbox"][name="${kdEscapeAttr(param)}"]`)];
  const active = boxes.find((cb) => cb.checked && !cb.disabled);
  select.value = active ? active.value : '';
}

function kdComfortFilterApplyToFacets(form, targetVal) {
  const root = kdGetToolbarRoot();
  if (!root || !form) return false;
  return kdFacetFilterApplyToFacets(form, root.dataset.comfortFilterParam, targetVal);
}

/** Match triangles to `#KdToolbarSortBy` — does NOT read URL (URL is stale until after facet AJAX completes). */
function kdTrianglesReflectSortState() {
  const hidden = document.getElementById('KdToolbarSortBy');
  if (!hidden) return;

  const v = hidden.value.trim();
  document.querySelectorAll('.kd-price-tri').forEach((btn) => {
    const sv = btn.getAttribute('data-sort-value');
    const on = !!(sv && v && sv === v);
    btn.classList.toggle('kd-price-tri--active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
}

/** Use after facets refresh or back/forward: align hidden `sort_by` + triangles with the address bar. */
function kdToolbarSortHydrateFromUrl() {
  const hidden = document.getElementById('KdToolbarSortBy');
  if (!hidden) return;

  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get('sort_by');
    if (fromUrl !== null && fromUrl !== '') hidden.value = fromUrl;
  } catch {
    /* ignore */
  }

  kdTrianglesReflectSortState();
}

function kdApplySortValue(form, sortValue) {
  const hidden = document.getElementById('KdToolbarSortBy');
  if (!hidden || !form) return;
  hidden.value = sortValue;
  kdTrianglesReflectSortState();
  form.dispatchEvent(new Event('input', { bubbles: true }));
}

function kdBindPriceSortButtons(form) {
  document.querySelectorAll('.kd-price-tri').forEach((btn) => {
    btn.addEventListener('click', () => {
      const v = btn.getAttribute('data-sort-value');
      if (!v) return;
      kdApplySortValue(form, v);
    });
  });
}

function kdBindPrimaryPills(form) {
  const wrap = document.getElementById('KdPrimaryPills');
  if (!wrap || !form) return;

  wrap.addEventListener('click', (e) => {
    const btn = e.target.closest('.kd-toolbar-pill');
    if (!(btn instanceof HTMLButtonElement) || btn.disabled) return;
    const val = btn.dataset.value ?? '';
    kdPrimaryFilterApplyToFacets(form, val);
    const productSelect = document.getElementById('KdProductSpotlight');
    if (productSelect) {
      productSelect.value = '';
      kdProductSpotlightReveal('');
    }
  });
}

function kdSpotlightAttachGrid(productId) {
  const grid = document.getElementById('product-grid');
  if (!grid) return;
  const on = !!(productId && productId.trim() !== '');
  grid.classList.toggle('kd-product-grid--spotlight-active', on);
}

function kdRebuildProductDropdown() {
  const select = document.getElementById('KdProductSpotlight');
  const root = kdGetToolbarRoot();
  if (!select || !root) return;

  const seeAllProducts = root.dataset.seeAllProducts || 'See all';
  const prev = select.value;
  select.innerHTML = '';
  const allOpt = document.createElement('option');
  allOpt.value = '';
  allOpt.textContent = seeAllProducts;
  select.appendChild(allOpt);

  document.querySelectorAll('#product-grid .grid__item').forEach((li) => {
    const pid = li.dataset.productId;
    const title = li.dataset.productTitle;
    if (!pid || !title) return;
    const opt = document.createElement('option');
    opt.value = pid;
    opt.textContent = title;
    select.appendChild(opt);
  });

  if (prev && [...select.options].some((o) => o.value === prev)) select.value = prev;
  else select.value = '';

  kdProductSpotlightReveal(select.value);
}

function kdProductSpotlightReveal(productId) {
  const id = typeof productId === 'string' ? productId.trim() : '';

  kdSpotlightAttachGrid(id);

  document.querySelectorAll('#product-grid .grid__item').forEach((li) => {
    const match = id !== '' && li.dataset.productId === id;
    li.classList.toggle('kd-collection-toolbar__spotlight-off', id !== '' && !match);
  });
}

function kdBindComfortFilter(form) {
  const select = document.getElementById('KdComfortFilter');
  const root = kdGetToolbarRoot();
  if (!select || !form || !root?.dataset.comfortFilterParam) return;

  kdComfortFilterSyncFromFacets(form);

  select.addEventListener('change', () => {
    kdComfortFilterApplyToFacets(form, select.value);
  });
}

function kdToolbarInit() {
  const form = kdGetFacetForm();
  const productSelect = document.getElementById('KdProductSpotlight');
  const collectionSelect = document.getElementById('KdCollectionJump');

  if (form && document.getElementById('KdPrimaryPills')) {
    kdPrimaryFilterSyncFromFacets(form);
    kdBindPrimaryPills(form);
  }

  if (form) {
    kdBindComfortFilter(form);

    form.addEventListener('change', (e) => {
      const t = e.target;
      if (!(t instanceof HTMLInputElement)) return;
      if (!t.matches('input[type="checkbox"][name*="filter"]')) return;
      kdPrimaryFilterSyncFromFacets(form);
      kdComfortFilterSyncFromFacets(form);
    });
  }

  if (form && document.getElementById('KdToolbarSortBy')) {
    kdToolbarSortHydrateFromUrl();
    kdBindPriceSortButtons(form);
  }

  productSelect?.addEventListener('change', () => {
    kdProductSpotlightReveal(productSelect.value);
    if (productSelect.value) {
      const card = document.getElementById(`ProductCard-${productSelect.value}`);
      card?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  kdBindCollectionDropdown(collectionSelect);
  kdRebuildProductDropdown();
}

function kdBindCollectionDropdown(select) {
  if (!(select instanceof HTMLSelectElement)) return;

  const root = kdGetToolbarRoot();
  const allCollectionsLabel = root?.dataset.allCollectionsLabel || 'All Collections';
  const collectionsLabel = root?.dataset.collectionsLabel || 'Filter By Collection';
  const currentPath = window.location.pathname;
  const currentCollectionHandleMatch = currentPath.match(/^\/collections\/([^/]+)/);
  const currentCollectionHandle = currentCollectionHandleMatch ? currentCollectionHandleMatch[1] : '';

  const baseOption = document.createElement('option');
  baseOption.value = '';
  baseOption.textContent = collectionsLabel;

  const allOption = document.createElement('option');
  allOption.value = '/collections';
  allOption.textContent = allCollectionsLabel;

  select.innerHTML = '';
  select.appendChild(baseOption);
  select.appendChild(allOption);

  fetch('/collections.json?limit=250')
    .then((response) => response.json())
    .then((data) => {
      const list = Array.isArray(data?.collections) ? data.collections : [];

      list.forEach((entry) => {
        if (!entry?.handle || !entry?.title) return;
        const handle = String(entry.handle).toLowerCase();
        const title = String(entry.title).toLowerCase().trim();
        if (handle === 'mandatory-fees' || title === 'mandatory fees') {
          return;
        }
        const option = document.createElement('option');
        option.value = `/collections/${entry.handle}`;
        option.textContent = entry.title;
        if (currentCollectionHandle && entry.handle === currentCollectionHandle) {
          option.selected = true;
        }
        select.appendChild(option);
      });
    })
    .catch(() => {
      // Keep base/all options only if request fails.
    });

  select.addEventListener('change', () => {
    if (!select.value) return;
    window.location.href = select.value;
  });
}

document.addEventListener('DOMContentLoaded', kdToolbarInit);
document.addEventListener('kd:products-updated', () => {
  const form = kdGetFacetForm();
  kdPrimaryFilterSyncFromFacets(form);
  kdComfortFilterSyncFromFacets(form);
  kdToolbarSortHydrateFromUrl();
  kdRebuildProductDropdown();
});
